import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowRefresh03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M16.777 20.268a9.6 9.6 0 0 0 4.778-8.317c0-4.03-2.47-7.48-5.972-8.903m0 14.303v4.801h4.777M7.223 3.732a9.6 9.6 0 0 0-4.778 8.317c0 4.03 2.47 7.48 5.972 8.904m0-14.304V1.848H3.64"
    />
  </svg>
);
export default SvgArrowRefresh03;
